import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import * as React from 'react'

import SessionCard from '../session-card'
import SessionIndexComponent from '@builder/react-ui/scheduler/session-index'

const SessionCardListDraggableItem = ({ session, index, weekendSessions }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: session.id })

  const style = {
    transform: transform ? CSS.Transform.toString(transform) : undefined,
    transition
  }

  const sid = session.id
  return (
    <div
      className='flex gap-8 flex-row items-center'
      ref={setNodeRef}
      style={style}
      {...attributes}
    >
      <SessionIndexComponent
        status={session.skipped ? 'skipped' : session.status}
        id={session.id}
        indexNumber={index}
      />
      <SessionCard
        className='border-8 border-indigo-600'
        data-qa-name={`session-${sid}`}
        {...session}
        sessionStatus={session.skipped ? 'skipped' : session.status}
        dragHandleProps={listeners}
        totalWeekendSessions={weekendSessions}
      />
    </div>
  )
}

export default SessionCardListDraggableItem
